import { Component, OnInit } from '@angular/core';
import { CustomerCareService } from '@app/shared/services/cx/customer-care.service';
import { catchError, EMPTY, Observable, switchMap, tap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { HelpCenterService } from '@app/shared/services/cx/help-center.service';

@Component({
  selector: 'app-goole-calendar-config',
  templateUrl: './goole-calendar-config.component.html',
  styleUrls: ['./goole-calendar-config.component.sass'],
})
export class GooleCalendarConfigComponent implements OnInit {
  googleAuthUrl$!: Observable<string>;
  googleAuthValidation$!: Observable<any>;
  isError = false;

  constructor(private readonly _helpCenterSvc: HelpCenterService, private readonly _authSvc: AuthService) {}

  ngOnInit(): void {
    this._authSvc.user$
      .pipe(
        tap(user => {
          this.googleAuthUrl$ = this._helpCenterSvc.getGoogleAuthorizationURL(user?.email || '');
          this.googleAuthValidation$ = this._helpCenterSvc.getGoogleCalendarValidation(user?.email || '').pipe(
            catchError(err => {
              this.isError = true;

              return EMPTY;
            })
          );
        })
      )
      .subscribe();
  }
}
